module.exports = __webpack_public_path__ + "img/ico-nature-fun.5f8fa18b.svg";